import { Box, CircularProgress, Alert, Snackbar, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { FormContainer } from '../components/PetForm/FormContainer';
import { usePet } from '../context/usePet';
import { ModalDelete } from '../components/ModalDelete';

export default function PetFormPage() {
  const { id } = useParams();
  const { isDataLoading, error, handleCloseError, petData } = usePet();
  const mode = id ? 'edit' : 'create';

  if (isDataLoading && mode === 'edit') {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '400px' 
      }}>
        <CircularProgress />
      </Box>
    );
  }

  // Verificar se os dados do pet estão disponíveis no modo de edição
  if (mode === 'edit' && !isDataLoading && !petData) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '400px' 
      }}>
        <Typography variant="h6" color="error">
          Pet não encontrado
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Snackbar 
        open={!!error} 
        autoHideDuration={6000} 
        onClose={handleCloseError}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
          {typeof error === 'string' ? error : 'Erro desconhecido'}
        </Alert>
      </Snackbar>

      <FormContainer mode={mode} />
      <ModalDelete />
    </>
  );
} 